<template>
	<div class="page profile-page">
		<van-nav-bar :title="xuanfeidata.xuanfei_name || ''" class="profile-nav">
			<template #left>
				<van-icon name="arrow-left" color="#222" size="22" @click="back()" />
			</template>
		</van-nav-bar>
		<section class="profile-card">
			<p class="title">{{ xuanfeidata.vo_title || 'Details of the beautiful woman' }}</p>
			<div class="profile-meta">
				<p><strong>Number:</strong> <span>{{ xuanfeidata.xuanfei_name || '--' }}</span></p>
				<p><strong>Area:</strong> <span>{{ xuanfeidata.address || '--' }}</span></p>
				<div class="profile-stats">
					<div class="stat">
						<strong>{{ pageViews }}</strong>
						<span>Page views</span>
					</div>
					<div class="stat">
						<strong>{{ xuanfeidata.dianzan || 0 }}</strong>
						<span>Number of likes</span>
					</div>
				</div>
			</div>
			<van-swipe v-if="detailImages.length" class="profile-gallery" :autoplay="3200" :duration="500" indicator-color="#7d3fb3">
				<van-swipe-item v-for="(image, index) in detailImages" :key="index">
					<van-image width="100%" height="100%" fit="cover" :src="image" />
				</van-swipe-item>
			</van-swipe>
		</section>
	</div>
</template>

<script>
export default {
	data() {
		return {
			xuanfeidata: []
		};
	},
	methods: {
		back() {
			this.$router.back();
		},
		getxuanfeidata() {
			this.$http({
				method: 'get',
				url: 'xuanfeidata',
				data: { id: this.$route.query.id }
			}).then(res => {
				this.xuanfeidata = res.data;
			});
		},
	},
	computed: {
		detailImages() {
			return Array.isArray(this.xuanfeidata.img_url) ? this.xuanfeidata.img_url.filter(Boolean).slice(0, 3) : [];
		},
		pageViews() {
			const views = this.xuanfeidata.page_views || this.xuanfeidata.views || this.xuanfeidata.browse;
			return views === undefined || views === null || views === '' ? '--' : views;
		}
	},
	created() {
		this.getxuanfeidata();
	}
};
</script>

<style>
.profile-page {
	min-height: 100vh;
	background: #f6f6f8;
}
.profile-nav {
	background: #fff;
	border-bottom: 1px solid #eee;
}
.profile-nav .van-nav-bar__title {
	color: #222;
	font-size: 1rem;
}
.profile-card {
	margin: 0.55rem;
	padding: 0.7rem 0.55rem 0.75rem;
	border: 1px solid #8c4bc4;
	border-radius: 0.55rem;
	background: #fff;
}
.title {
	margin: 0 0 0.65rem;
	font-size: 0.75rem;
	font-weight: 600;
	text-align: center;
	color: #783cb3;
}
.profile-meta {
	margin: 0;
	padding: 0;
	text-align: left;
	color: #333;
}
.profile-meta p {
	margin: 0 0 0.42rem;
	font-size: 0.78rem;
}
.profile-meta p span {
	color: #8b7346;
}
.profile-stats {
	display: flex;
	justify-content: space-between;
	margin: 0.55rem 0 0.65rem;
}
.stat {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 50%;
}
.stat strong {
	font-size: 1.45rem;
	line-height: 1.2;
	color: #7d3fb3;
}
.stat span {
	margin-top: 0.15rem;
	font-size: 0.62rem;
	color: #8b7346;
}
.profile-gallery {
	width: 100%;
	height: 22.65rem;
	margin: 0 auto;
	border-radius: 0.38rem;
	overflow: hidden;
}
</style>
